import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";

/**
 * 21ik Platform paneli rotaları (/yonetim altında, yol başında "/" olmadan). Firma kabuğunun `app/routes.ts`
 * listesine EKLENMEZ: sayfalar firma menüsüyle değil PlatformShell içinde açılır (App.tsx).
 */
export const platformRoutes: FeatureRoute[] = [
  { path: "firmalar", Component: lazy(() => import("./TenantsPage")) },
  { path: "firmalar/:id", Component: lazy(() => import("./TenantPage")) },
  { path: "kisiler", Component: lazy(() => import("./PeoplePage")) },
  { path: "isler", Component: lazy(() => import("./JobsPage")) },
  { path: "kayit", Component: lazy(() => import("./PlatformAuditPage")) },
  { path: "yoneticiler", Component: lazy(() => import("./AdminsPage")) },
];

export const PlatformOverviewPage = lazy(() => import("./OverviewPage"));
export const PlatformLoginPage = lazy(() => import("./PlatformLoginPage"));
